import { ENLIGHTEN_APP_SUBPATH } from "./constants";

export const buildAppUrl = (path: string): string => {
  const prefix = typeof window !== "undefined"
    && window.location.pathname.startsWith(ENLIGHTEN_APP_SUBPATH)
    ? ENLIGHTEN_APP_SUBPATH
    : "";
  return `${prefix}${path.startsWith("/") ? path : `/${path}`}`;
};
